// Prev/next buttons for the sub-collections row. Idempotent: safe if the script loads more than once.
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var list = root.querySelector('[data-subcol-list]');
    var nav = root.querySelector('[data-subcol-nav]');
    var prev = root.querySelector('[data-subcol-prev]');
    var next = root.querySelector('[data-subcol-next]');
    if (!list || !nav || !prev || !next) return;
    var queued = false;

    function update() {
      queued = false;
      nav.hidden = !(list.scrollWidth > list.clientWidth + 2);
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    }
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }
    function step(dir) {
      var first = list.firstElementChild;
      var w = first ? first.getBoundingClientRect().width + 16 : list.clientWidth;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollBy({ left: dir * w * 2, behavior: reduce ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    list.addEventListener('scroll', schedule, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(list);
    else window.addEventListener('resize', schedule);
    update();
  }

  function run() { document.querySelectorAll('[data-subcol]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
